import { I18n } from '../types';
import { FormField } from '@hilma/netina2all';

export const generalStationDetails: FormField<I18n>[] = [
    {
        description: i18n => i18n.sm.address.stationName,
        id: 'stationName',
        required: true
    },
    {
        description: i18n => i18n.am.email,
        id: 'email',
        ltr: true,
        required: true
    },
    {
        description: i18n => i18n.am.phone,
        id: 'phone',
        ltr: true,
        required: true,
        readonly: true
    },
    {
        description: i18n => i18n.am.additionalPhone,
        id: 'additionalPhone',
        ltr: true,
    },
    {
        description: i18n => i18n.sm.managerDetails.fullName,
        id: 'fullName',
        required: true
    },
]

export const additionalStationDetails: FormField<I18n>[] = [
    {
        description: i18n => i18n.sm.address.arrivalInstructions,
        tooltip: i18n => i18n.sm.address.tooltip,
        id: 'arrivalInstructions',
        multiline: true,
        rows: 3,
        placeholder: i18n => i18n.sm.address.aiPlaceholder,
        required: true
    },
    {
        description: i18n => i18n.sm.additionalDetails.maxKits,
        tooltip: i18n => i18n.sm.additionalDetails.tooltipMaxKits,
        id: 'maxKits',
        required: true
    },
    {
        description: i18n => i18n.sm.additionalDetails.goalKits,
        tooltip: i18n => i18n.sm.additionalDetails.tooltipGoalKits,
        id: 'goalKits',
    },
    {
        description: i18n => i18n.sm.additionalDetails.accessible,
        id: 'accessible',
        inputType: 'checkbox'
    },
]